// extracted by mini-css-extract-plugin
module.exports = {"advantageBlock":"advantageBlock-KRT8h","iconAdvantage":"iconAdvantage--Ibbk","textAdvantage":"textAdvantage-V9D5y"};